import React, { Component } from 'react';
import * as ROUTES from '../../constants/routes';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { signInAnon, anonProfileCreate, validateCode, validateCode_v2, updateProfileName, endLoading } from '../../store/actions/authActions';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Footer from '../Footer';
import LogoHeader from '../Header';
import styles from '../Styles';
import LiquidLoadingBlock from '../Loading/loadingCup';
import moment from 'moment';
import LogoAlt from '../../images/LogoAlt.png';




const INITIAL_STATE = {
  code_validated: false,
  redirectToHome: false,
  redirectToName: false,
  name: '',
  setName: true,
};

class AnonSignInMyCode extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  componentDidMount(){    
    this.props.endLoading();

    if ( this.props.match.params.id) {
        // we have a code, let's verify

          this.props.validateCode_v2( this.props.match.params.id, this.props.match.params.you );
        
    }

    setTimeout(() => {
      /* If they haven't connected after 10 seconds, something's wrong. Try again. */
      if ( this.props.auth.uid !== undefined && this.props.user.isEmpty === true) {
        this.props.anonProfileCreate(this.props.gol_auth);
      }
    }, 10000)
  }

  componentDidUpdate(prevProps, prevState){

    if ( this.props.authCodeValid === true && this.props.authMessage === null ){
        if ( this.props.user.isLoaded === true && this.props.user.isEmpty === true ){
          if ( this.props.user.isEmpty === true && !this.props.auth.uid ){
            this.props.signInAnon( this.props.match.params.id, this.props.gol_auth.myCode );
          } else {}
        } else {
          if ( this.props.auth.uid !== undefined && this.props.user.isEmpty !== true ){
            this.setState({
              ...this.state,
              redirectToName: true
            });
          }
        } 
    }

    if ( this.props.authMessage === 'SIGNOUT_SUCCESS' && prevProps.authMessage !== this.props.authMessage ){
        if ( this.props.authCodeValid ){
            this.props.signInAnon(  this.props.match.params.id, this.props.gol_auth.myCode );
        }
    }

    if ( this.props.authMessage === 'LOGIN_SUCCESS' && prevProps.authMessage !== this.props.authMessage ){
        // we have just logged in
        setTimeout(() => {        
          this.props.anonProfileCreate(this.props.gol_auth);
        }, 1500);
    }


    if ( this.props.authMessage === 'LOGIN_PROFILE_CREATED' && prevProps.authMessage !== this.props.authMessage ){
        // we have just logged in
        this.setState({
            ...this.state,
            redirectToName: true
        })
    }
  }

  render() {
    const { t, classes } = this.props;
    console.log('gol_auth', this.props.gol_auth);

    /* MUST BE AT TOP */
    if ( this.state.redirectToHome ){
        return <Redirect to={ROUTES.LANDING} />;
    }
    if ( this.state.redirectToName ){
        if ( this.props.match.params.you !== undefined ){
          return <Redirect to={ROUTES.LANDING} />;
        } else {
          return <Redirect to={ROUTES.CHANGE_NAME} />;
        }
    }
    if ( this.props.authCodeValid === true ){
        return (
            <div className='meta-react'>
             
              <div className='outer-container' style={{paddingTop: 150}}>
                <div className='container'>
                  <div className='row'>
                    <div className='col-12' align="center">
                      <Typography variant="h3">Code Validated</Typography>
                      <Typography variant="body1">Joining Session...</Typography>
                      <div className={classes.spacingTop}>
                      <LiquidLoadingBlock />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
        );
    }  

    if ( this.props.authCodeValid === false ){
        return (
            <div className='meta-react'>    
              <div className='outer-container' style={{paddingTop: 150}}>
                <div className='container'>
                  <div className='row'>
                    <div className='col-12' align="center">
                      {
                        this.props.gol_auth.planned_session !== false ?
                        <div>
                          <Typography variant="h6">You're a little early!</Typography>
                          <Typography variant="body1">The session, <span style={{fontWeight: "bold"}}>{this.props.gol_auth.planned_session.title}</span>, has not yet started.</Typography>
                          <Typography variant="body2">Please come back on <span style={{fontWeight: "bold"}}>{moment(this.props.gol_auth.planned_session.date).format("LLLL")}</span></Typography>

                          <img src={LogoAlt} alt='Solta' style={{maxWidth: "300px", paddingTop: 100}} />

                        </div>
                        :
                        this.props.gol_auth.authMessage === 'Code Already Used' ?
                          <div><Typography variant="h6">An Error has occured</Typography><Typography variant="body1">This code has already been used, but no need to worry, during your session ask the host for the generic link to log in.</Typography>
                           <img src={LogoAlt} alt='Solta' style={{maxWidth: "300px", paddingTop: 100}} /></div>
                        :
                        <div><Typography variant="h6">An Error has occured</Typography><Typography variant="body1">Invalid Code.</Typography>
                         <img src={LogoAlt} alt='Solta' style={{maxWidth: "300px", paddingTop: 100}} /></div>                        
                      }      
                    </div>
                  </div>
                </div>
              </div>
          
            </div>
        );
    }

    /* catch all return */
    return (
        <div className='meta-react'>
         
          <div className='outer-container'  style={{paddingTop: 150}}>
            <div className='container'>
              <div className='row'>
                <div className='col-12' align="center">
                  <Typography variant="h3">Validating Code</Typography>
                  <Typography variant="body1" className={classes.spacingTop}>One moment please...</Typography>                      
                </div>
              </div>
            </div>
          </div>
         
        </div>
    );
  } 
}

AnonSignInMyCode.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    user: state.firebase.profile,
    gol_auth: state.gol_auth,
    authError: state.gol_auth.authError,
    authMessage: state.gol_auth.authMessage,
    authPopUp: state.gol_auth.authPopUp,
    authErrorPopUp: state.gol_auth.authErrorPopUp,
    authCodeValid: state.gol_auth.authCodeValid,
    sessionHost: state.gol_auth.sessionHost,
    authCode: state.gol_auth.authCode,
    isLoading: state.gol_auth.isLoading,
    setName: state.gol_auth.setName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signInAnon: (creds) => dispatch(signInAnon(creds)),
    anonProfileCreate: (a) => dispatch(anonProfileCreate(a)),
    updateProfileName: (creds) => dispatch(updateProfileName(creds)),
    endLoading: () => dispatch(endLoading()),
    validateCode: (code) => dispatch(validateCode(code)),
    validateCode_v2: (code, you) => dispatch(validateCode_v2(code, you))
  };
};

export default compose(withTranslation(), withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(AnonSignInMyCode);